export default __webpack_public_path__ + "static/media/btn-drift-on@2x.50ca7cfd.png";